import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClipboardCheck, UserPlus, FolderOpen, Loader2, CheckCircle2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { api } from "../../lib/api";

const ROWS = [
  ["patient_name", "Paciente"], ["sex", "Sexo"], ["birth_date", "Nacimiento"], ["curp", "CURP"],
  ["guardian_name", "Tutor"], ["guardian_relationship", "Parentesco"], ["phone", "Teléfono"], ["email", "Correo"],
  ["address", "Domicilio"], ["blood_type", "Tipo de sangre"], ["allergies", "Alergias"],
  ["medications", "Medicamentos"], ["conditions", "Antecedentes"], ["reason", "Motivo"],
];
const SEX = { M: "Masculino", F: "Femenino" };

export default function IntakeDialog({ appointmentId, onClose }) {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!appointmentId) return;
    setData(null);
    api.get(`/appointments/${appointmentId}/intake`).then((r) => setData(r.data)).catch(() => setData({ error: true }));
  }, [appointmentId]);

  const it = data?.intake;
  const isNew = data && !data.error && !data.patient_id;
  const go = () => { onClose(); navigate(isNew ? `/pacientes?cita=${appointmentId}` : `/pacientes/${data.patient_id}?tab=citas`); };

  return (
    <Dialog open={!!appointmentId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="intake-dialog" className="rounded-3xl max-w-lg max-h-[88vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-outfit text-brand-ink flex items-center gap-2"><ClipboardCheck size={18} className="text-brand-sage" /> Pre-registro · {data?.patient_name || ""}</DialogTitle>
          <DialogDescription>{isNew ? "Paciente de primera vez: crea su expediente con estos datos ya llenos." : "Paciente con expediente: los datos ya se agregaron a su ficha."}</DialogDescription>
        </DialogHeader>
        {!data ? <div className="h-24 flex items-center justify-center"><Loader2 className="animate-spin text-brand-sage" /></div> : data.error ? (
          <p data-testid="intake-dialog-error" className="text-sm text-red-600">No se pudo cargar el pre-registro. Intenta de nuevo.</p>
        ) : (
          <div className="space-y-4">
            {data.attendance_confirmed_at && <p data-testid="intake-dialog-confirmed" className="text-sm font-semibold text-brand-sageDark flex items-center gap-1.5"><CheckCircle2 size={16} /> El paciente confirmó su asistencia</p>}
            {it ? (
              <dl className="grid grid-cols-[110px_1fr] gap-x-3 gap-y-2 text-sm" data-testid="intake-dialog-data">
                {ROWS.filter(([k]) => it[k]).map(([k, l]) => (
                  <div key={k} className="contents"><dt className="text-muted-foreground">{l}</dt><dd className="font-semibold text-brand-ink break-words">{k === "sex" ? SEX[it[k]] : it[k]}</dd></div>
                ))}
              </dl>
            ) : <p data-testid="intake-dialog-empty" className="text-sm text-muted-foreground">El paciente aún no llena su pre-registro.{data.prospect?.phone ? ` Teléfono: ${data.prospect.phone}` : ""}</p>}
            <button data-testid="intake-dialog-action" onClick={go}
              className="w-full flex items-center justify-center gap-2 bg-brand-ink hover:opacity-90 text-white font-outfit font-semibold py-3 rounded-2xl transition-opacity">
              {isNew ? <><UserPlus size={16} /> Crear expediente con estos datos</> : <><FolderOpen size={16} /> Abrir expediente</>}
            </button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
